import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=61378ae6&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"
import style0 from "./Main.vue?vue&type=style&index=0&id=61378ae6&prod&scoped=true&lang=css"
import style1 from "./Main.vue?vue&type=style&index=1&id=61378ae6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61378ae6",
  null
  
)

export default component.exports